import { Configurations } from '../models';

export const CHANGE_COPY_DISABLED = 'CHANGE_COPY_DISABLED' as const;

/** для обновления переинициализации стейта */
export const INIT = 'INIT' as const;

export const initAction = (state: Partial<Configurations>) => ({
  type: INIT,
  payload: state,
});

export const changeCopyDisabled = (disabled: boolean) => ({
  type: CHANGE_COPY_DISABLED,
  payload: disabled,
});
